export const mutZurWut = {
  id: "mut-zur-wut",
  thumbnailUrl: "/assets/Mut_Zur_Wut/00-MW-1x1-1440-Thumbnail.webp",
  disciplines: "Poster",
  year: 2025,
  project: "Grüner wird’s nicht",
  initiatedAt: "Self-Initiated work",
  shortInitiatedAt: "Self-initiated",
  additionalInfo: {
    awards: [
      "Top 100 finalists, Mut zur Wut International Poster Competition 2025",
    ],
    exhibitions: ["Völkerkundemuseum Heidelberg"],
    publications: ["Mut zur Wut 2025 Austellungskatalog"],
  },
  description:
    '"Grüner wird’s nicht" is a poster project addressing the absence of environmental issues in the 2025 German federal election campaign. Using visual irony, the work deliberately undermines expectations of "green" imagery, reinforcing the statement that sustainability is no longer part of the political narrative.',
  credits: ["Self-initiated work"],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Mut_Zur_Wut/01-MW-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Mut_Zur_Wut/02-MW-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Mut_Zur_Wut/03-MW-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Mut_Zur_Wut/04-MW-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
